export const STATE_KEY = 'loyaltyDashboard'

export const SET_LOYALTY_DASHBOARD = 'SET_LOYALTY_DASHBOARD'
export const SET_LOYALTY_LOADING = 'SET_LOYALTY_LOADING'
export const SET_LOYALTY_ERROR = 'SET_LOYALTY_ERROR'
export const SET_BEST_CUSTOMERS = 'SET_BEST_CUSTOMERS'
export const SET_BEST_CUSTOMERS_LOADING = 'SET_BEST_CUSTOMERS_LOADING'
export const SET_SEGMENTS = 'SET_SEGMENTS'
export const SET_SEGMENTS_LOADING = 'SET_SEGMENTS_LOADING'
export const SET_SALES_TEAM = 'SET_SALES_TEAM'
export const SET_SALES_TEAM_LOADING = 'SET_SALES_TEAM_LOADING'

const initialState = {
  loading: false,
  hasLoaded: false,
  error: null,
  results: [],
  startDate: null,
  endDate: null,
  bestCustomers: null,
  bestCustomersLoading: false,
  segments: null,
  segmentsLoading: false,
  salesTeam: [],
  salesTeamLoading: false,
}

export default function loyaltyDashboardReducers(state = initialState, action) {
  switch (action.type) {
    case SET_LOYALTY_LOADING:
      return { ...state, loading: true, error: null }

    case SET_LOYALTY_DASHBOARD:
      return {
        ...state,
        loading: false,
        hasLoaded: true,
        error: null,
        results: action.payload.results,
        startDate: action.payload.startDate,
        endDate: action.payload.endDate,
      }

    case SET_LOYALTY_ERROR:
      return { ...state, loading: false, hasLoaded: true, error: action.payload }

    case SET_BEST_CUSTOMERS_LOADING:
      return { ...state, bestCustomersLoading: true }

    case SET_BEST_CUSTOMERS:
      return {
        ...state,
        bestCustomersLoading: false,
        bestCustomers: action.payload,
      }

    case SET_SEGMENTS_LOADING:
      return { ...state, segmentsLoading: true }

    case SET_SEGMENTS:
      return {
        ...state,
        segmentsLoading: false,
        segments: action.payload,
      }

    case SET_SALES_TEAM_LOADING:
      return { ...state, salesTeamLoading: true }

    case SET_SALES_TEAM:
      return {
        ...state,
        salesTeamLoading: false,
        salesTeam: action.payload,
      }

    default:
      return state
  }
}
